<template>
  <div class="sidebar-article mks-col-12 mks-col-4@md mks-col-end">
    <mks-spacer class="sidebar__section--bottom hide-on-mobile-tablet">
      <mks-heading tag="h3">Événements</mks-heading>
      <mks-spacer spacing="m">
        <EventTeaser 
          v-for="event in events" 
          :key="event._id" 
          :event="event" 
          variant="line"
          @click="track('Event', {id: event._id, slug: event.slug})">
        </EventTeaser>
      </mks-spacer>
    </mks-spacer>
    <BuilderContent model="article-sidebar" class="sidebar-custom-content" :query="sidebarQuery">
    </BuilderContent>
  </div>
</template>
<script>
import { useAsyncData } from 'nuxt/app';
export default defineNuxtComponent({
  props: {
    topic: {
      type: String,
      required: true,
      default: null
    }
  },
  data() {
    return {
      events: []
    }
  },
  async setup(props) {
    const nuxtApp = useNuxtApp();
    const data = {};

    const COUNT_EVENTS = 3;

    try {
      const relatedCriterias = {
        limit: COUNT_EVENTS,
        only: 'events',
        strict: true,
        eventCriteria: {
          $or: [
            {source: { $exists: false}},
            {source: { name: { $ne: 'helloasso' }}}
          ]
        },
        topics: props.topic.value.data.id
      }

      let {data: events} = await useAsyncData(() => nuxtApp.$api.Builder.queryContent(relatedCriterias));
      data.events = events.value;

      if (events.value.length < COUNT_EVENTS) {
        // if not enough events, try to get more with relaxed query
        relatedCriterias.strict = false;
        delete relatedCriterias.topics;

        let {data: otherEvents } = await useAsyncData(() => nuxtApp.$api.Builder.queryContent(relatedCriterias));
        // remove events already in data.events
        otherEvents.value = otherEvents.value.filter((event) => !data.events.find((e) => e._id === event._id));
        // add other events to data.events to try reaching the limit needed
        data.events = [...data.events, ...otherEvents.value.slice(0, COUNT_EVENTS - data.events.length)];
      }
    }
    catch (err) {
      console.log(err);
    }

    return data;
    
  },
  computed: {
    sidebarQuery() {
      if (this.topic.value.data.slug === 'entrepreneuriat') {
        return {data: {'topic': {id: this.topic.id}}};
      }
      return {};
    }
  },
  methods: {
    track(type, data) {
      this.$store.dispatch("analytics/track", {
        event: "Makesense Chiche - Sidebar " + type,
        data
      });
    }
  }
})
</script>
<style lang="scss" scoped>
.sidebar-article {
  // position: sticky;
  // top: var(--header-height);
  display: flex;
  flex-direction: column;
  // height: auto;
  align-self: flex-start;
  
  @media (min-width: 992px) {
    height: 100%;
    padding-bottom: $space-xxxl;
    
    :deep(.sidebar-custom-content) {
      flex: 1;

      &>*, *[builder-model] {
        height: 100%;
      }

      .builder-blocks {
        height: 100%;

        .sticky {
          position: sticky;
          top: var(--header-height);
        }
      }
    }
  }
}
.sidebar__section--bottom {
  margin-bottom: $space-xxl;
}

</style>
